import { render, staticRenderFns } from "./FooterBox.vue?vue&type=template&id=3ea3e93f&"
import script from "./FooterBox.vue?vue&type=script&lang=js&"
export * from "./FooterBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports